import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetSelectedMatType, ShowToastMessage } from "./redux/actions";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import NavBar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import ToastMessage from "./components/toastMessage/ToastMessage";
import alphabeMat from "./assets/images/alphabetMat.png";
import numberMat from "./assets/images/numberMat.png";
import closeIcon from "./assets/icons/cancelCircle.png";
import leftArrowIcon from "./assets/icons/circle_left_arrow.png";
import useOnlineStatus from "./utils/useOnlineStatus";

function MainView() {
  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
  const [isGradeNavVisible, setIsGradeNavVisible] = useState(false);
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [selectedMat, setSelectedMat] = useState(null);
  let location = useLocation();
  const dispatch = useDispatch();
  const selectedMatType = useSelector((state) => state.gameStore.gameData.selectedMatType);
  const navigate = useNavigate();
  const isOnline = useOnlineStatus();
  const prevStatus = useRef(isOnline);
  useEffect(() => {
    if (location.pathname.includes("/grade")) {
      setIsGradeNavVisible(false);
    }
    if (!location.pathname.includes("/subject")) {
      setIsSubMenuVisible(false);
    }
    if (location.pathname.includes("/search")) {
      setIsSearchVisible(true);
    } else {
      setIsSearchVisible(false);
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, selectedMatType]);
  // const matType = sessionStorage.getItem("matType");
  // console.log("matType", selectedMat);
  const isThankPage = location.pathname === "/thanks";

  useEffect(() => {
    if (prevStatus.current !== isOnline) {
      if (!isOnline) {
        dispatch(ShowToastMessage("No Internet Connection"));
      } else {
        dispatch(ShowToastMessage("Back Online"));
      }

      prevStatus.current = isOnline;
    }
  }, [isOnline, dispatch]);
  return (
    <div className="main-container">
      <ToastMessage />{
        !selectedMat ? (
          <>
            <div className="overLayContainer">
              <div className="modalPopupContainer">
                <div className="popupHeading">
                  {/* <div><img src={leftArrowIcon} alt="" /></div> */}
                  <div><h2>Select a side to continue playing</h2></div>
                  {/* <button className="popupButton"><img src={closeIcon} alt="" /></button> */}
                </div>
                <div className="popupContent">
                  <div className="popupButtonContainer">
                    <button className={`popupButton ${selectedMat === "ALPHABET" ? "selected" : "faded"}`}
                      // onClick={() => { setSelectedMat("ALPHABET"); sessionStorage.setItem("matType", "ALPHABET") }}
                      onClick={() => {
                        setSelectedMat("ALPHABET");
                        dispatch(SetSelectedMatType("ALPHABET"));
                        navigate(`/`);
                      }}
                    >
                      <p>Alphabet Mat</p>
                      <img src={alphabeMat} alt="" />
                    </button>
                    <button className={`popupButton ${selectedMat === "NUMBER" ? "selected" : "faded"}`}
                      // onClick={() => { setSelectedMat("NUMBER"); sessionStorage.setItem("matType", "NUMBER") }}
                      onClick={() => {
                        setSelectedMat("NUMBER");
                        dispatch(SetSelectedMatType("NUMBER"));
                        navigate(`/`);
                      }}
                    >
                      <p>Number Mat</p>
                      <img src={numberMat} alt="" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {!isThankPage && (
              <NavBar
                isSearchVisible={isSearchVisible}
                isSubMenuVisible={isSubMenuVisible}
                setIsSubMenuVisible={setIsSubMenuVisible}
                isGradeNavVisible={setIsGradeNavVisible}
                setSelectedMat={setSelectedMat}
              />
            )}
            <div
              className={`page-view-container ${isSubMenuVisible ? "with-sub-menu" : ""
                } ${isThankPage ? "thanks" : ""}`}
            >
              <Outlet isSubMenuVisible={isSubMenuVisible} />
            </div>
            {!isThankPage && <Footer />}
          </>
        )
      }
    </div>
  );
}

export default MainView;
